import {CONTENT_SUBMISSION_KIND} from '@/types/contentSubmission';
import type {BaseFilterOption} from '@/types/models/creator-crm/filter';
import type {CampaignCreator} from '@/views/campaigns/content-submissions/types/campaignCreator';

export const CONTENT_TYPE_OPTIONS: BaseFilterOption[] = [
  {
    id: CONTENT_SUBMISSION_KIND.PHOTO,
    localeLabelKey: 'Photos',
    value: CONTENT_SUBMISSION_KIND.PHOTO,
  },
  {
    id: CONTENT_SUBMISSION_KIND.VIDEO,
    localeLabelKey: 'Videos',
    value: CONTENT_SUBMISSION_KIND.VIDEO,
  },
  {
    id: CONTENT_SUBMISSION_KIND.BLOG,
    localeLabelKey: 'Blog Posts',
    value: CONTENT_SUBMISSION_KIND.BLOG,
  },
  {
    id: CONTENT_SUBMISSION_KIND.MIXED_MEDIA,
    localeLabelKey: 'Story',
    value: CONTENT_SUBMISSION_KIND.MIXED_MEDIA,
  },
];

export type ContentSubmissionsFilters = {
  talent: CampaignCreator | null;
  contentType: BaseFilterOption[];
  status: BaseFilterOption[];
};

export const INITIAL_FILTERS: ContentSubmissionsFilters = {
  talent: null,
  contentType: [],
  status: [],
};
